import { getCachedLogoPath, getLogoPath, hasValue, noValue } from "@repo/helpers";
import { memo, useEffect, useState } from "react";

interface LogoImageProps {
	customerName: string;
	type: "dark" | "light";
	className?: string;
	noDefault?: boolean;
}

// Shows /Content/Logos/<variant><customerName>.png, falling back to the TLP logo unless noDefault is set
export const LogoImage = memo(function LogoImage({ customerName, type, className, noDefault }: LogoImageProps) {
	const cachedPath = getCachedLogoPath(customerName);
	const [loaded, setLoaded] = useState<{ name: string; path: string }>(null);

	useEffect(() => {
		if (hasValue(getCachedLogoPath(customerName))) return undefined;
		let cancelled = false;
		void getLogoPath(customerName, type, noDefault).then((path) => {
			if (!cancelled) setLoaded({ name: customerName, path });
		});
		return () => {
			cancelled = true;
		};
	}, [customerName, type, noDefault]);

	const logoPath = cachedPath ?? (loaded?.name === customerName ? loaded.path : null);
	if (noValue(logoPath)) return null;

	return <img className={className} alt={`${customerName} Logo`} src={logoPath} id="ctl00_imgLogo" />;
});
